<div class="modal-popup">
    <div class="modal-content edit-layer-panel">
        <ng-form #editLayerForm="ngForm">
            <header class="modal-header">
                <h2 class="modal-title">
                    <span>{{ 'TCS.Mapviewer.LayerContextMenu.EditLayer' | translate }}</span>
                </h2>
                <gsp-button
                    [type]="ButtonType.Icon"
                    (action)="closeEditPanel()"
                    [iconClass]="'icon-ModelClose'"
                ></gsp-button>
            </header>

            <div class="edit-layer-scroll-container" [ngClass]="{ 'non-templated-layer': template && !template.id }">
                <custom-scroll>
                    <loading *ngIf="loading" class="loading-align-center"></loading>
                    <div class="modal-body" *ngIf="!loading">
                        <div class="modal-group edit-layer-form">
                            <div class="edit-layer-form-group">
                                <div class="edit-layer-form-group-label" translate="name"></div>
                                <div class="edit-layer-form-group-input layer-name">
                                    <gsp-text
                                        #name="ngModel"
                                        [type]="GspTextType.GENERIC"
                                        [id]="'edit-layer-name'"
                                        inputClass="gsp-form-input"
                                        name="layerName"
                                        placeholder="{{ 'TCS.Layer.EnterLayerName' | translate }}"
                                        [(ngModel)]="layer.layerName"
                                        length="44"
                                        required="true"
                                        errorTooltipMsg="{{ getErrorText(name.errors) }}"
                                        focusElement="true"
                                    ></gsp-text>
                                </div>
                            </div>

                            <div class="label-section" *ngIf="layer.geometryType === GeometryTypes.POINT">
                                <div class="sub-heading">
                                    {{ 'TC.Common.Label' | translate }}
                                </div>

                                <div class="label-item-group">
                                    <label translate="TC.Common.Field"></label>
                                    <gsp-dropdown
                                        id="label-field"
                                        name="label"
                                        [options]="labelOptions"
                                        [(ngModel)]="selectedLabelOption"
                                        [overlapMenuOn]="true"
                                        idField="name"
                                        textField="displayName"
                                    ></gsp-dropdown>
                                </div>
                            </div>
                        </div>

                        <style-symbology-panel
                            [layerEditMode]="true"
                            [template]="template"
                            [(templateStyle)]="templateStyle"
                            [layer]="layer"
                        ></style-symbology-panel>
                    </div>
                </custom-scroll>
            </div>
            <div class="modal-footer" *ngIf="!loading">
                <gsp-button
                    [type]="ButtonType.Primary"
                    (click)="saveLayer()"
                    [disabled]="isSaveDisabled()"
                    text="{{ 'save' | translate }}"
                ></gsp-button>
                <gsp-button
                    [type]="ButtonType.Default"
                    (click)="closeEditPanel()"
                    text="{{ 'cancel' | translate }}"
                ></gsp-button>
            </div>
        </ng-form>
    </div>
</div>
